// @ts-nocheck
import React, {FC, useMemo} from 'react';
import {MaterialReactTable, MRT_ColumnDef as MRTColumnDef} from 'material-react-table';
import Moment from 'react-moment';
import PrinterType from '../../../pages/Printers/printerType';
import NotificationEdit from '../../../pages/Notifications/notification-edit';
import NotificationDelete from '../../../pages/Notifications/notification-delete';
import {Typography} from '@mui/material';

interface NotificationListProps {
  isLoading: boolean;
  notifications: OverviewNotification[];
}

export const NotificationList: FC<NotificationListProps> = ({
  isLoading,
  notifications,
}) => {
  const columns = useMemo<MRTColumnDef<OverviewNotification>[]>(
      () => [
        {
          header: 'ID',
          accessorKey: 'id',
        },
        {
          header: 'Date Created',
          accessorKey: 'created_at',
          Cell: ({cell}) => (
            <Moment format="DD-MM-YYYY">{cell.getValue()}</Moment>
          ),
        },
        {
          header: 'Subject',
          accessorKey: 'subject',
        },
        {
          header: 'Message',
          accessorKey: 'message',
          Cell: ({cell}) => (
            <div
              className="nofification-text"
              dangerouslySetInnerHTML={{__html: cell.getValue()}}
            />
          ),
        },
        {
          header: 'Printer Type',
          accessorKey: 'printer_type',
          Cell: ({cell}) => (
            <PrinterType printer={{printer_type: cell.getValue()}} />
          ),
        },
        {
          header: 'Actions',
          accessorKey: 'actions',
          enableSorting: false,
          enableColumnFilter: false,
          Cell: ({row}) => (
            <>
              <NotificationEdit notification={row.original} />
              <NotificationDelete notification={row.original} />
            </>
          ),
        },
      ],
      [],
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={notifications}
      enableSorting
      enableColumnFilters
      enablePagination
      enableGlobalFilter
      state={{isLoading}}
      muiTablePaperProps={{
        elevation: 0,
      }}
      renderTopToolbarCustomActions={() => (
        <Typography variant="h6">Notifications</Typography>
      )}
    />
  );
};
